import { Partner } from "app/models";
import { toDate } from "./date.util";

export const mapPartner = (partner: Partner): Partner => ({
  ...partner,
  createdAt: toDate(partner.createdAt),
  updatedAt: toDate(partner.updatedAt),
});
